<template>
  <div class="consign-record">
    <div class="main-title">
      <p v-if="view=='list'" @click="cancelHandle">电池寄存记录</p>
      <p v-if="view=='process'" @click="cancelHandle">电池寄存记录</p>
      <p v-if="view=='process'">>完成进度</p>
    </div>
    <div class="main-body" v-if="view=='list'">
      <div class="filter-bar">
        <div class="item">
          <span>用户手机号：</span>
          <el-input v-model="userInfo" placeholder="请输入寄存者手机号或用户编号"></el-input>
        </div>
        <span>寄存时间：</span>
        <div class="value-label">
          <el-date-picker
            v-model="beginTime"
            class="date-global"
            size="mini"
            type="datetime"
            format="yyyy-MM-dd HH:mm"
            value-format="yyyy-MM-dd HH:mm"
            placeholder="选择开始时间">
          </el-date-picker>
          <span>-</span>
          <el-date-picker
            v-model="endTime"
            size="mini"
            class="date-global"
            type="datetime"
            format="yyyy-MM-dd HH:mm"
            value-format="yyyy-MM-dd HH:mm"
            placeholder="选择结束时间">
          </el-date-picker>
        </div>
        <div class="item">
          <el-button type="primary" @click="getDataList">查询</el-button>
        </div>
      </div>

      <table class="table-custom" style="margin-top: 20px">
        <thead>
        <tr>
          <th style="width: 150px">记录编号</th>
          <th>下单时间</th>
          <th>完成时间</th>
          <th>操作类型</th>
          <th>手机号</th>
          <th>状态</th>
          <th>换电柜编号</th>
          <th>换电柜名称</th>
          <th>格口号</th>
          <th>电池通讯板号</th>
          <th width="100px">操作</th>
        </tr>
        </thead>
        <tbody v-if="dataList.length>0">
        <tr v-for="(item, index) in dataList" :key="index">
          <td>{{ item.number }}</td>
          <td>{{ item.createTime }}</td>
          <td>{{ item.finishTime }}</td>
          <td>{{ typeList[item.type] }}</td>
          <td>{{ item.userPhone }}</td>
          <td>{{ statusList[item.status] }}</td>
          <td>{{ item.primaryDeviceNo }}</td>
          <td>{{ item.deviceName }}</td>
          <td>{{ item.chargePortSeqNo }}</td>
          <td>{{ item.communicationBoardNo }}</td>
          <td>
            <div class="text-btn fixed-width-75" @click="onProcessBtnClick(item)">查看进度</div>
          </td>
        </tr>
        </tbody>
        <tbody v-else>
        <tr>
          <td colspan="11" style="text-align: center">暂无数据</td>
        </tr>
        </tbody>
      </table>
      <div class="page-box">
        <div class="page-count">第{{ currentPage }}页，当前页{{ dataList.length }}条，共{{ total }}条</div>
        <div class="page-count">
          跳转到第
          <el-input v-model="page" class="page-choose fixed-width-35" size="mini"></el-input>
          页
        </div>
        <div class="page-count text-btn" @click="toPage">跳转</div>
        <div class="pre-btn" :class="beginIndex <= 0 ? 'disabled' : ''" @click="prevPage">上一页</div>
        <div class="next-btn" :class="reachEnd ? 'disabled' : ''" @click="nextPage">下一页</div>
      </div>
    </div>
    <div class="main-body" v-if="view == 'process'">
      <battery-consign-record-process-view :editData="editData"
                                           @cancel="cancelHandle"></battery-consign-record-process-view>
    </div>
  </div>
</template>

<script>
import Utils from "../../utils/utils";
import BatteryConsignRecordProcessView from "./batteryConsignRecordProcessView";


export default {
  name: "userInviteRecord",
  components: {BatteryConsignRecordProcessView},
  data() {
    return {
      view: 'list',
      statusList: {
        '1': '创建',
        '2': '完成',
        '3': '取消',
      },
      typeList: {
        '1': '寄存',
        '2': '领取',
      },
      dataList: [],
      beginIndex: 0,
      pageSize: 10,
      total: 0,
      page: '',
      reachEnd: true,
      beginTime: "",
      endTime: "",
      userInfo: "",
      editData: {},
    }
  },

  computed: {
    currentPage() {
      return Math.floor(this.beginIndex / this.pageSize) + 1
    },
    totalPage() {
      return Math.ceil(this.total / this.pageSize)
    }
  },

  mounted() {
    this.endTime = Utils.getCurrentDate() + " 23:59";
    this.getDataList();
    if (this.$route.query.recordNo) {
      this.view = 'process';
      this.$nextTick(() => {
        this.editData = {
          number: this.$route.query.recordNo,
          type: this.$route.query.type,
        };
      });
    }
  },

  methods: {

    getDataList() {
      let params = {
        userInfo: this.userInfo,
        beginTime: this.beginTime,
        endTime: this.endTime,
        beginIndex: this.beginIndex,
        pageSize: this.pageSize + 1
      }
      this.$http.get('/managementPlatform/electricity/queryBatteryConsignRecord?' + this.$qs.stringify(params)
      ).then(response => {
        let res = response.data;
        if (!res || !res.result) {
          return this.$message.error(res.message)
        }
        this.reachEnd = res.ldata.length < this.pageSize + 1;
        if (!this.reachEnd) {
          res.ldata.pop();
        }
        this.dataList = res.ldata;
        this.total = res.mdata.total || '0'
      }).catch(function (response) {
        console.log(response);
      });
    },

    toPage() {
      if (!this.page || isNaN(this.page)) {
        return this.$message.warning("请输入跳转的页数");
      }
      this.page = parseInt(this.page);
      if (this.pageSize < 1 || this.page > this.totalPage) {
        return this.$message.warning("请输入正确的页码");
      }
      this.beginIndex = (this.page - 1) * this.pageSize;
      this.getDataList();
    },

    prevPage() {
      this.beginIndex -= this.pageSize;
      this.getDataList();
    },

    nextPage() {
      this.beginIndex += this.pageSize;
      this.getDataList();
    },
    onProcessBtnClick(data) {
      this.view = 'process';
      this.$nextTick(() => {
        this.editData = data;
      });
    },
    cancelHandle() {
      this.view = 'list';
      this.getDataList();
    },
  }
}
</script>

<style lang="scss" scoped>
.consign-record {
  .filter-bar {
    display: flex;
    align-items: center;

    .item {
      margin-right: 10px;
      min-width: 260px;

      .el-input {
        width: 160px;
      }

      .el-cascader,
      .el-select {
        width: 180px;
      }
    }
  }

  .table-custom {
    .text-btn {
      width: 50px;
      height: 24px;
      line-height: 24px;
      color: #417505;
      display: inline-block;
      background-color: #BEE6B3;
      cursor: pointer;
    }

    .fixed-width-75 {
      width: 75px;
    }

    .fixed-width-100 {
      width: 100px;
    }

    .mt4 {
      margin-top: 4px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/orderMgmt/batteryConsignRecord.vue